import {
  LitElement,
  html,
  css,
  classMap,
  range,
  map,
  utils,
} from '@hh/global.js'
const { throttle } = utils

class BrandOne extends LitElement {
  static properties = {
    itemCount: {
      attribute: 'item-count',
      type: Number,
    },
    _items: {
      state: true,
      type: Array,
    },
    _current: {
      state: true,
      type: Number,
    },
  }

  constructor() {
    super()
    this._current = 1
    this.debouncedScroll = throttle((e) => {
      this.onScroll(e)
    }, 300)
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListener('scroll', this.debouncedScroll)
  }

  firstUpdated() {
    this._items = this.content.querySelectorAll('li')
    this.content.addEventListener('scroll', this.debouncedScroll.bind(this))
  }

  onScroll(e) {
    this._current =
      Math.round(this.content.scrollLeft / this._items[0].clientWidth) + 1
  }

  get content() {
    const slot = this.shadowRoot.querySelector('slot[name="content"]')
    return slot.assignedElements()[0]
  }

  render() {
    return html`
      <div>
        <slot name="header"></slot>
        <slot name="content"></slot>
        <div
          class=${classMap({
            pagination: true,
            hidden: this.itemCount === 1,
          })}
        >
          ${map(
            range(this.itemCount),
            (index) =>
              html`
                <div
                  class=${classMap({
                    indicator: true,
                    active: this._current === index + 1,
                  })}
                  aria-hidden="true"
                ></div>
              `
          )}
        </div>
      </div>
    `
  }

  static styles = css`
    .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin: 4.2rem 0 2rem;
      gap: 1rem;
    }

    .pagination.hidden {
      display: none;
    }

    @media screen and (min-width: 750px) {
      .pagination {
        display: none;
      }
    }

    .indicator {
      width: 6.5rem;
      height: 0.2rem;
      background-color: var(--hh-color-neutral);
    }

    .indicator.active {
      background-color: var(--hh-color-brand-primary);
    }
  `
}

customElements.define('hh-brand-one', BrandOne)
